// extracted by mini-css-extract-plugin
export default {"errorPage":"errorPage-ofn_S"};